const parseSort = (sortBy, sortDesc = []) => {
  return sortBy?.map((columnId, index) => `${columnId}:${sortDesc[index] ? 'desc' : 'asc'}`).join(',');
}

const filterValueToArray = (val) => {
  if (Array.isArray(val))
    return val;

  return typeof val === 'string' && val.includes(',') 
    ? val.split(',') 
    : [val];
}

const parseFilters = (filters, mandatoryFilters) => {
  for (const [key, val] of Object.entries(mandatoryFilters ?? {})) {
    if (val === undefined || val === null)
      continue;

    let filtersArray = filterValueToArray(val);

    if (filters[key])
      filtersArray = [...new Set([...filterValueToArray(filters[key]), ...filtersArray])];
      
    filters[key] = filtersArray;
  }

  for (const [fKey, fVal] of Object.entries(filters)) {
    if (Array.isArray(fVal)) {
      filters[fKey] = fVal.map(v => encodeURIComponent(v)).join(','); // e.g. status=1,2,3,4
    }
  }
  
  return filters;
}

export { parseFilters, parseSort };